<template>
  <Base icon="mdi-google-circles-extended" :satisfied="requirement.satisfied" tooltip>
    <span>
      {{ requirement.disciplines.length }}
      {{ requirement.disciplines.length | pluralize('Discipline') }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not' : '' }} have a qualification in the discipline of
      <span v-for="discipline in requirement.disciplines">
        {{ discipline != requirement.disciplines[0] ? 'or' : '' }}<br />
        <strong>{{ discipline.name }}</strong>
      </span>
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
}
</script>
